import {useDispatch, useSelector} from "react-redux";
import {useHistory, useRouteMatch} from "react-router-dom";
import {AppState} from "../../../store";
import React from "react";
import LoadingForm from "../../shared-components/loading-form/LoadingForm";
import {Field, Form, Formik} from "formik";
import LoadingButton from "../../shared-components/loading-button/LoadingButton";
import {Button, Grid, MenuItem, TextField, Typography} from "@material-ui/core";
import PageHeader from "../../shared-components/page-header/PageHeader";
import {useTranslation} from "react-i18next";
import {employeesFormStyles} from "../employees.styles";
import {
    resetEmployeeIdentificationForm,
    setEmployeeIdentificationForm
} from "../store/employee-identification-form.slice";
import {updateAccessibility} from "../store/update-accessibility.slice";
import {resetEmployeeForm} from "../store/employee-form.slice";

const EmployeeIdentification = () => {
    const classes = employeesFormStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const history = useHistory();
    const {params}: any = useRouteMatch();
    const empLoading = useSelector((state: AppState) => state.employees.allEmployees.loading);
    const updateEmpLoading = useSelector((state: AppState) => state.employees.updateEmployee.loading);
    const employeeForm = useSelector((state: AppState) => state.employees.employeeForm);
    const identificationForm = useSelector((state: AppState) => state.employees.employeeIdentificationForm)

    const handleChange = (e: any) => {
        dispatch(
            setEmployeeIdentificationForm({
                ...identificationForm,
                [e.target.name]: e.target.value
            })
        )
    };

    if (empLoading) {
        return <LoadingForm/>;
    }

    return (
        <div>
            <PageHeader
                title={`Employee information ${" "} ${employeeForm.fullName}`}
                desc={t("app.main.agency.agentsList.agentEdit.desc", "To change the information, change the form below and click Save Changes")}
                backButton={() => {
                    dispatch(resetEmployeeIdentificationForm());
                    history.push("/employees/employees-list");
                }}
            />
            <div className={classes.formWrapper}>
                <Formik
                    initialValues={identificationForm}
                    onSubmit={() => {
                        dispatch(updateAccessibility({
                            id: params.id,
                            body: {
                                ...identificationForm
                            },
                            onSuccess: () => {
                                history.push("/employees/employees-list");
                                dispatch(resetEmployeeIdentificationForm());
                            },
                        }))
                    }}
                >
                    <Form>
                        <div className={classes.row}
                             style={{
                                 borderTop: "1px solid #e7e7e7",
                                 borderBottom: "1px solid #e7e7e7",
                             }}>
                            <Typography style={{margin: "0.4rem 8.45rem 0 0.2rem", width: "137px"}}>
                                {t("app.main.agency.agentsList.agentEdit.accountIdentification.label1", "State")}:
                            </Typography>
                            <Field
                                onChange={handleChange}
                                variant="outlined"
                                name="status"
                                value={identificationForm.status}
                                size='small'
                                select
                                as={TextField}
                                required
                            >
                                <MenuItem key={'true'} value='true'>
                                    Active
                                </MenuItem>
                                <MenuItem key={'false'} value='false'>
                                    Deactivate
                                </MenuItem>
                            </Field>
                        </div>
                        <div className={classes.row}
                             style={{
                                 borderTop: "1px solid #e7e7e7"
                             }}>
                            <Typography style={{margin: "0.4rem 8.45rem 0 0.2rem", width: "137px"}}>
                                {t("app.main.agency.create.identifyEmail", "Identification (E-mail)")}:
                            </Typography>
                            <Field
                                style={{width: '100%'}}
                                label={t("app.main.agency.create.identifyEmail", "Identification (E-mail)")}
                                onChange={handleChange}
                                value={identificationForm.email}
                                variant='outlined'
                                size='small'
                                name='email'
                                as={TextField}
                                required
                            />
                        </div>
                        <div className={classes.row}>
                            <Typography style={{margin: "0.4rem 8.45rem 0 0.2rem", width: "137px"}}>
                                {t("app.main.employees.create.password", "Password")}:
                            </Typography>
                            <Field
                                type='password'
                                style={{width: '100%'}}
                                label={t("app.main.employees.create.password", "Password")}
                                onChange={handleChange}
                                value={identificationForm.password}
                                variant='outlined'
                                size='small'
                                name='password'
                                as={TextField}
                            />
                        </div>
                        <Grid container justify='flex-end' alignItems='center' style={{marginTop: '20px'}}>
                            <Grid item>
                                <LoadingButton
                                    type='submit'
                                    btnTitle={t("app.main.flights.flightList.editPage.saveChanges", "Save Changes")}
                                    size='medium'
                                    isLoading={updateEmpLoading}
                                />
                                <Button
                                    onClick={() => {
                                        dispatch(resetEmployeeForm());
                                        history.push("/employees/employees-list");
                                    }}>
                                    {t("app.main.schedules.splitPassenger.closeButton", "Close")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                </Formik>
            </div>
        </div>
    );
};

export default EmployeeIdentification;